<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { printPage } from '@utils';

import { XLink } from '@clicksign/excalibur';

import CompanyInfo from '@components/CompanyInfo.vue';
import CertifyInfo from '@components/CertifyInfo.vue';

const store = useStore();
const { t } = useI18n();

const validDocument = computed(() => store.getters['fileUpload/validDocument']);
</script>

<template>
  <section :class="$style.documentValidatorResult">
    <header :class="$style.header">
      <XLink
        no-padding
        to="/"
      >
        {{ t('general.action.returnToHome') }}
      </XLink>

      <div :class="$style.actions">
        <XLink
          icon="file-lines"
          to="/validators"
          no-padding
        >
          {{ t('accessTerm.display.validate_another_document') }}
        </XLink>

        <XLink
          icon="print"
          no-padding
          to="#"
          @click="printPage"
        >
          {{ t('accessTerm.display.print') }}
        </XLink>
      </div>
    </header>

    <CompanyInfo
      :document="validDocument"
      :is-access-term="false"
    />

    <CertifyInfo :valid-document="validDocument" />
  </section>
</template>

<style lang="scss" module>
.documentValidatorResult {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;

  .header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: var(--space-large-x);
    gap: var(--space-small-xx);

    @media print {
      display: none;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: var(--space-small-xx);
  }
}
</style>
